import { render, staticRenderFns } from "./AllCampaigns.vue?vue&type=template&id=ce5043fc&scoped=true&"
import script from "./AllCampaigns.vue?vue&type=script&lang=js&"
export * from "./AllCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./AllCampaigns.vue?vue&type=style&index=0&id=ce5043fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5043fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
